//
// Generated class ConceptItem
//

/// <reference path="ConceptItem_ManagedObject.ts" />

class ConceptItem extends ConceptItem_ManagedObject
{

}
